import type { IconSvgObject } from './types';

const ArrowLeft04Icon: IconSvgObject = [
  ["path", { d: "M10 12H20", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M4.00008 12.0001L10.0001 7.99976V15.9998L4.00008 12.0001Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default ArrowLeft04Icon;
